// 定义枚举类型，存储所有可用的事件名称
export enum EventName {
  Tabchange = "Tabchange",
  updateNavigationCart = "updateNavigationCart",
  updateFollowStatus = "updateFollowStatus", // 更新商品收藏状态
}
// 定义事件名称和数据类型
export interface TabchangeEventData {
  tabs: string;
}

// 定义收藏状态变化的事件数据类型
export interface FollowStatusEventData {
  spuId: string; // 商品ID
  isFollow: boolean; // 是否已收藏
}
